<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes
  >
    <template v-slot="{ toggle, isToggled }">
      <a href="/" id="nav-logo-large" style="margin: auto"
        ><img class="jipvio-logo" src="/img/jipvio-logo-w.png"
      /></a>
      <a href="/" id="nav-logo-small" style="margin: auto"
        ><img class="jipvio-logo" src="/img/jipvio-logo-w-s.png"
      /></a>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import { Popover } from "element-ui";
export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped></style>
